import React from 'react'

import { Col, Container, Row } from '@/components/ui-compat'

import Main from '../components/Main'

const Auth = ({ children }) => (
  <>
    <Main className="flex w-full">
      <Container className="flex flex-col">
        <Row className="h-full">
          <Col className="mx-auto h-full">
            {children}
          </Col>
        </Row>
      </Container>
    </Main>
  </>
)

export default Auth
